module.exports = __webpack_public_path__ + "assets/img/package.b5436d3a.svg";